// This is the parent component of a modal: ModalVendornominate

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import AnimateOnScroll from "./AnimateOnScroll";
import GenericModal from "./GenericModal";
import ModalVendornominate from "./ModalVendornominate";
import NominateSuccessModal from "./NominateSuccessModal";
import { postVendorrecommendation } from "./redux/slices/VendorrecommendationsThunks";
import Footer from "./shared/Footer";
import Navbar from "./shared/Navbar";
import { isValidEmail, isValidPhoneNumber } from "./utils/regex";

export default function 
 Vendornominate() {
  const navigate = useNavigate();
  // Modal logic goes here for Vendornominate
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nominateModalOpen, setNominateModalOpen] = useState(false);
  const formRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [showError, setShowError] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const dispatch = useDispatch();
  const { postStatus, error } = useSelector(
    (state) => state.vendorrecommendations
  );

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email_address: "",
    company_name: "",
    company_website: "",
    reason_for_nomination: "",
  });

  const handleChange = (eOrValue, optionalName) => {
    if (typeof eOrValue === "object" && eOrValue.target) {
      const { name, value } = eOrValue.target;
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [optionalName]: eOrValue });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasSubmitted(true);
    const {
      first_name,
      last_name,
      phone_number,
      email_address,
      company_name,
      company_website,
      reason_for_nomination,
    } = formData;

    if (
      !first_name ||
      !last_name ||
      !phone_number ||
      !email_address ||
      !company_name ||
      !company_website ||
      !reason_for_nomination
    ) {
      setShowError(true);

      return;
    } else {
      setShowError(false);
    }

    if (!isValidEmail(email_address)) {
      toast.error("Please enter a valid email address");
      return;
    }

    const result = await dispatch(
      postVendorrecommendation({
        first_name,
        last_name,
        phone_number,
        email_address,
        company_name,
        company_website,
        reason_for_nomination,
        id: uuidv4(),
      })
    );

    if (postVendorrecommendation.fulfilled.match(result)) {
      // toast.success("Vendor recommendation submitted!");
      setFormData({
        first_name: "",
        last_name: "",
        phone_number: "",
        email_address: "",
        company_name: "",
        company_website: "",
        reason_for_nomination: "",
      });
      setHasSubmitted(false);
    } else {
      setHasSubmitted(false);
      toast.error(result.payload || "Submission failed");
    }
    openModal();
  };

  return (
    <RootWrapperVendornominate>
    
      <AnimateOnScroll ease={"easeInOut"} duration={0.3} delay={0}>
        <SectionBanner2>
          <Frame19>
            <Right>
              <OwlArrow1 src="https://d3nakrlcog1u3z.cloudfront.net/1749636457677-7311b6409783c4e9135b330296518f67f6b1cf3e.png" />
            </Right>
            <Left_0001>
              <Frame6>
                <UnlockThePowerOfReferrals>
                  Unlock the power of referrals
                </UnlockThePowerOfReferrals>
                <PaartnerBelievesThatThoseWhoCanConnectTheirFriendsToTheServiceProvidersAgenciesAndTechPlatformsThatCanHelpThemShouldBeEncouragedAndRewardedForDoingSo>
                  Paartner believes that those who can connect their friends to
                  the service providers, agencies and tech platforms that can
                  help them should be encouraged, and rewarded, for doing so.
                </PaartnerBelievesThatThoseWhoCanConnectTheirFriendsToTheServiceProvidersAgenciesAndTechPlatformsThatCanHelpThemShouldBeEncouragedAndRewardedForDoingSo>
              </Frame6>
            </Left_0001>
          </Frame19>
          <Glow>
            <Ellipse2 />
            <Ellipse1 />
            <Ellipse2 />
          </Glow>
        </SectionBanner2>
      </AnimateOnScroll>
      <Section>
        <Wrapper>
          <ContentBlock1>
            <Content>
              <EarningCashForMakingReferralsIsEasierThanEver>
                Why should a vendor apply to join Paartner?
              </EarningCashForMakingReferralsIsEasierThanEver>
              <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                Paartner is all about quality referrals, delivered straight to
                vendors. Strong, hot, qualifiable leads that have come from our
                member’s network, friends that have an expressed need for the
                services you provide and are ready to be connected.
                <br />
                <br />
                Our goal is to give you a steady stream of new prospects to
                engage with that have already been told good things about you
                and have a need to engage, and contract, now. <br />
                <br />
                And referrals that come from advocates are likely to have a
                higher win rate, close faster and bring realised revenue sooner,
                creating real impact on your bottom line. <br />
                <br />
                <span style={{ color: "rgba(166, 43, 127, 1) " }}>
                  Sales teams will love you for it!
                </span>
              </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
            </Content>
          </ContentBlock1>
        </Wrapper>
      </Section>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001>
              <Image>
                <Frame1530>
                  <Frame1533>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Customer refferals account for 54% of all B2B leads.”
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>SellersCommerce</SellersCommerce>
                    </Frame1532>
                  </Frame1533>
                </Frame1530>
              </Image>
              <Content_0001>
                <Frame12>
                  <Leads>Leads</Leads>
                </Frame12>
                <Frame46>
                  <Frame46_0001>
                    <IncreaseSalesPipeline>
                      Increase Sales Pipeline
                    </IncreaseSalesPipeline>
                  </Frame46_0001>
                </Frame46>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Paartner can help you fill your firm’s sales pipeline with
                  quality leads. Driving referrals from members that understand
                  your firm, understand the prospect’s needs and feel there is a
                  good fit.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001 direction={"column-reverse"}>
              <Content_0001>
                <Frame12>
                  <Leads>Revenue</Leads>
                </Frame12>
                <Frame46_0002>
                  <IncreaseSalesPipeline_0001>
                    Increase contribution to Revenue
                  </IncreaseSalesPipeline_0001>
                </Frame46_0002>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Not only can working with Paartner boost your sales pipeline,
                  but referrals have a high win rate, and convert faster,
                  ensuring your team makes the best use of their time, and
                  budgets. We like to help you demonstrate your contribution to
                  revenue, helping you demonstrate your value to the wider
                  business.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
              <Image>
                <Frame1530>
                  <Frame1533_0001>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532_0001>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Referral leads boast a 30% higher conversion rate"
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Finances Online</SellersCommerce>
                    </Frame1532_0001>
                  </Frame1533_0001>
                </Frame1530>
              </Image>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001>
              <Image>
                <Frame1530>
                  <Frame1533>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Customers referred by other customers have a 37% higher
                        retention rate"
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Deloitte</SellersCommerce>
                    </Frame1532>
                  </Frame1533>
                </Frame1530>
              </Image>
              <Content_0001>
                <Frame12>
                  <Leads>Profit</Leads>
                </Frame12>
                <Frame46>
                  <Frame46_0001>
                    <IncreaseSalesPipeline>
                      Increase profit margin
                    </IncreaseSalesPipeline>
                  </Frame46_0001>
                </Frame46>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  No upfront costs are necessary to get started on Paartner and
                  Fixed Referral Rewards (FRR) are only due once you sign
                  contracts with new clients. Everything can be a predictable
                  cost, paid only on success whilst referred clients often stay
                  with you for longer. Great!
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001 direction={"column-reverse"}>
              <Content_0001>
                <Frame12>
                  <Leads>Efficiency</Leads>
                </Frame12>
                <Frame46_0002>
                  <IncreaseSalesPipeline_0001>
                    Drive higher spend to pipeline ratio
                  </IncreaseSalesPipeline_0001>
                </Frame46_0002>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Paartner can act as a turnkey extension to your marketing team
                  and our mutual success model ensures that everything you do to
                  drive leads via the platform is likely to generate more,
                  quality, pipeline than most other activities and channels, be
                  easily attributable and optimised Customer Acquisition Cost
                  (CAC).
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
              <Image>
                <Frame1530>
                  <Frame1533_0001>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532_0001>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Referrals are the channel with the highest conversion
                        rate."
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Marketo</SellersCommerce>
                    </Frame1532_0001>
                  </Frame1533_0001>
                </Frame1530>
              </Image>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001>
              <Image>
                <Frame1530>
                  <Frame1533>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Rewards boost referral among acquaintances."
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Deloitte</SellersCommerce>
                    </Frame1532>
                  </Frame1533>
                </Frame1530>
              </Image>
              <Content_0001>
                <Frame12>
                  <Leads>Advocacy</Leads>
                </Frame12>
                <Frame46>
                  <Frame46_0001>
                    <IncreaseSalesPipeline>
                      Mobilise Advocates
                    </IncreaseSalesPipeline>
                  </Frame46_0001>
                </Frame46>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Paartner can help you mobilise your existing, happy, clients,
                  who could make referrals to your firm but are currently not
                  encouraged or motivated to do so. Putting them at the heart of
                  your lead generation.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001 direction={"column-reverse"}>
              <Content_0001>
                <Frame12>
                  <Leads>Brand</Leads>
                </Frame12>
                <Frame46>
                  <Frame46_0001>
                    <IncreaseSalesPipeline>
                      Strengthen your brand
                    </IncreaseSalesPipeline>
                  </Frame46_0001>
                </Frame46>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Your existing clients can help spread the good word about you,
                  but Paartner, and its Vendor ecosystem, bring even more
                  potential referrers (and clients) to within your reach.
                  Raising the profile of your brand and amplifying your good
                  name across the UK.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
              <Image>
                <Frame1530>
                  <Frame1533_0001>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532_0001>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        83% of people trust recommendations from friends and
                        family over other forms of marketing."
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Finances Online</SellersCommerce>
                    </Frame1532_0001>
                  </Frame1533_0001>
                </Frame1530>
              </Image>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001>
              <Image>
                <Frame1530>
                  <Frame1533>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        78% of marketers point to referrals as the source of
                        their most valuable leads."
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>Software Advice</SellersCommerce>
                    </Frame1532>
                  </Frame1533>
                </Frame1530>
              </Image>
              <Content_0001>
                <Frame12>
                  <Leads>Operations</Leads>
                </Frame12>
                <Frame46>
                  <Frame46_0001>
                    <IncreaseSalesPipeline>
                      Improve Operations
                    </IncreaseSalesPipeline>
                  </Frame46_0001>
                </Frame46>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Paartner makes tracking and reporting on marketing generated
                  pipeline much easier, improving the visibility and
                  predictability that can help your team prioritise their
                  limited bandwidth on the quality leads that have a higher
                  chance of conversion. Giving them flexibility to divert time
                  to other areas of the business.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
              </Content_0001>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section_0001>
        <Wrapper>
          <AnimateOnScroll>
            <ContentBlock1_0001 direction={"column-reverse"}>
              <Content_0001>
                <Frame12>
                  <Leads>Flexibility</Leads>
                </Frame12>
                <Frame46_0002>
                  <IncreaseSalesPipeline_0001>
                    Differentiate
                  </IncreaseSalesPipeline_0001>
                </Frame46_0002>
                <PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                  Success with Paartner could allow valuable resources to be
                  diverted to other areas of marketing (and the wider business)
                  and allow teams more freedom to do ‘new, exciting, stuff’,
                  increasing your team’s growth and retention.
                </PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit>
                <Frame1535>
                  <Devider />
                </Frame1535>
                <Frame1536>
                  <Frame47>
                    <ContentBox532>
                      <Frame1534>
                        <MoneyBill>
                          <Frame1544>
                            <MoneyBill_0001 xmlns="http://www.w3.org/2000/svg">
                              <path
                                fill="rgb(33, 37, 67)"
                                d="M4.375 1.875C4.375 3.28125 3.24219 4.375 1.875 4.375L1.875 10.625C3.24219 10.625 4.375 11.7578 4.375 13.125L18.125 13.125C18.125 11.7578 19.2188 10.625 20.625 10.625L20.625 4.375C19.2188 4.375 18.125 3.28125 18.125 1.875L4.375 1.875ZM0 2.5C0 1.13281 1.09375 0 2.5 0L20 0C21.3672 0 22.5 1.13281 22.5 2.5L22.5 12.5C22.5 13.9062 21.3672 15 20 15L2.5 15C1.09375 15 0 13.9062 0 12.5L0 2.5ZM11.25 3.75C12.5781 3.75 13.7891 4.49219 14.4922 5.625C15.1562 6.79688 15.1562 8.24219 14.4922 9.375C13.7891 10.5469 12.5781 11.25 11.25 11.25C9.88281 11.25 8.67188 10.5469 7.96875 9.375C7.30469 8.24219 7.30469 6.79688 7.96875 5.625C8.67188 4.49219 9.88281 3.75 11.25 3.75Z"
                              />
                            </MoneyBill_0001>
                          </Frame1544>
                        </MoneyBill>
                        <MutualSuccess>Mutual success</MutualSuccess>
                      </Frame1534>
                      <PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                        Paartner’s mutual success model means that rewards are
                        only due when you win a deal.
                      </PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                    </ContentBox532>
                    <ContenBox533>
                      <Frame1534>
                        <MoneyBill_0002>
                          <Frame1544_0001>
                            <MoneyBill_0003 xmlns="http://www.w3.org/2000/svg">
                              <path
                                fill="rgb(33, 37, 67)"
                                d="M5 0.9375C5 0.429688 5.39062 0 5.9375 0L10.3125 0C10.8203 0 11.25 0.429688 11.25 0.9375C11.25 1.48438 10.8203 1.875 10.3125 1.875L9.0625 1.875L9.0625 3.82812C10.7422 4.02344 12.2656 4.72656 13.4766 5.82031L14.6484 4.64844C15 4.29688 15.5859 4.29688 15.9375 4.64844C16.3281 5.03906 16.3281 5.625 15.9375 5.97656L14.7266 7.1875C15.6641 8.51562 16.25 10.1562 16.25 11.875C16.25 16.3672 12.5781 20 8.125 20C3.63281 20 0 16.3672 0 11.875C0 7.73438 3.125 4.29688 7.1875 3.82812L7.1875 1.875L5.9375 1.875C5.39062 1.875 5 1.48438 5 0.9375ZM8.125 18.125C10.3516 18.125 12.3828 16.9531 13.5156 15C14.6484 13.0859 14.6484 10.7031 13.5156 8.75C12.3828 6.83594 10.3516 5.625 8.125 5.625C5.85938 5.625 3.82812 6.83594 2.69531 8.75C1.5625 10.7031 1.5625 13.0859 2.69531 15C3.82812 16.9531 5.85938 18.125 8.125 18.125ZM9.0625 8.4375L9.0625 12.5C9.0625 13.0469 8.63281 13.4375 8.125 13.4375C7.57812 13.4375 7.1875 13.0469 7.1875 12.5L7.1875 8.4375C7.1875 7.92969 7.57812 7.5 8.125 7.5C8.63281 7.5 9.0625 7.92969 9.0625 8.4375Z"
                              />
                            </MoneyBill_0003>
                          </Frame1544_0001>
                        </MoneyBill_0002>
                        <MutualSuccess_0001>
                          No time-consuming legal agreements
                        </MutualSuccess_0001>
                      </Frame1534>
                      <PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                        Paartner handles the legal agreements with its members,
                        the rewards on offer and their payment so you don’t need
                        to.
                      </PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                    </ContenBox533>
                  </Frame47>
                  <Frame47>
                    <ContentBox532>
                      <Frame1534>
                        <MoneyBill>
                          <Frame1544>
                            <MoneyBill_0005 xmlns="http://www.w3.org/2000/svg">
                              <path
                                fill="rgb(33, 37, 67)"
                                d="M10.625 0.0390625L8.63281 2.03125C8.00781 2.1875 7.46094 2.5 6.99219 2.92969L5.97656 3.82812C5.54688 4.17969 5.03906 4.375 4.49219 4.375L3.75 4.375L3.75 9.375C4.53125 9.41406 5.27344 9.72656 5.85938 10.3125L8.55469 13.0078C8.82812 13.2812 9.21875 13.2812 9.45312 13.0078C9.53125 12.9688 9.57031 12.8906 9.60938 12.8125C9.72656 12.5 9.96094 12.2656 10.2734 12.1875C10.5859 12.1484 10.8984 12.2266 11.1328 12.4609L11.5625 12.8516C12.0312 13.3203 12.7344 13.3203 13.2031 12.8516C13.3984 12.6562 13.5156 12.3828 13.5547 12.1094C13.5547 11.7578 13.75 11.4453 14.0625 11.3281C14.375 11.1719 14.7266 11.2109 15.0391 11.4062C15.3906 11.6406 15.8984 11.6406 16.2109 11.2891C16.6016 10.9375 16.6016 10.3516 16.2109 9.96094L13.2812 6.99219L11.875 8.28125C10.8203 9.29688 9.17969 9.29688 8.08594 8.32031C6.83594 7.22656 6.79688 5.3125 8.00781 4.17969L10.7422 1.60156C11.8359 0.585938 13.2422 0 14.7266 0C16.1328 0 17.5 0.546875 18.5547 1.48438L19.7266 2.5L24.375 2.5C24.6875 2.5 25 2.8125 25 3.125L25 11.25C25 11.9531 24.4141 12.5 23.75 12.5L22.5 12.5C22.0312 12.5 21.6016 12.2656 21.4062 11.875L18.0859 11.875C17.9688 12.1484 17.7734 12.4219 17.5391 12.6172C16.875 13.2812 15.9766 13.5547 15.0781 13.3984C14.9609 13.7109 14.7656 13.9453 14.5312 14.1797C13.4766 15.2734 11.7969 15.3516 10.5859 14.5312C9.60938 15.3125 8.16406 15.2734 7.22656 14.3359L6.21094 13.2812L5.9375 13.0078L4.53125 11.6406C4.29688 11.4062 4.02344 11.2891 3.75 11.2891C3.75 11.9531 3.16406 12.5 2.5 12.5L1.25 12.5C0.546875 12.5 0 11.9531 0 11.25L0 3.125C0 2.8125 0.273438 2.5 0.625 2.5L4.49219 2.5C4.57031 2.5 4.64844 2.5 4.72656 2.42188L5.74219 1.52344C6.83594 0.546875 8.24219 0 9.6875 0L10.1172 0C10.2734 0 10.4297 0.0390625 10.625 0.0390625ZM21.25 10L21.25 4.375L19.375 4.375C19.1406 4.375 18.9062 4.29688 18.75 4.14062L17.3047 2.89062C16.6016 2.22656 15.6641 1.875 14.7266 1.875C13.7109 1.875 12.7734 2.26562 12.0312 2.96875L9.29688 5.54688C8.90625 5.9375 8.90625 6.5625 9.33594 6.91406C9.6875 7.26562 10.2344 7.26562 10.5859 6.91406L13.3984 4.33594C13.7891 3.98438 14.375 3.98438 14.7266 4.375C15.0781 4.76562 15.0391 5.35156 14.6875 5.70312L14.6484 5.74219L17.5391 8.63281C17.9297 9.02344 18.2031 9.53125 18.3203 10L21.25 10ZM2.5 10.625C2.5 10.3125 2.1875 10 1.875 10C1.52344 10 1.25 10.3125 1.25 10.625C1.25 10.9766 1.52344 11.25 1.875 11.25C2.1875 11.25 2.5 10.9766 2.5 10.625ZM23.125 11.25C23.4375 11.25 23.75 10.9766 23.75 10.625C23.75 10.3125 23.4375 10 23.125 10C22.7734 10 22.5 10.3125 22.5 10.625C22.5 10.9766 22.7734 11.25 23.125 11.25Z"
                              />
                            </MoneyBill_0005>
                          </Frame1544>
                        </MoneyBill>
                        <MutualSuccess_0002>
                          No negotiations with referrers
                        </MutualSuccess_0002>
                      </Frame1534>
                      <PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                        Paartner’s mutual success model means that rewards are
                        only due when you win a deal.
                      </PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                    </ContentBox532>
                    <ContenBox533>
                      <Frame1534>
                        <MoneyBill_0002>
                          <Frame1544_0001>
                            <MoneyBill_0007 xmlns="http://www.w3.org/2000/svg">
                              <path
                                fill="rgb(33, 37, 67)"
                                d="M12.5 18.125C12.8125 18.125 13.125 17.8516 13.125 17.5L13.125 6.25L10 6.25C9.29688 6.25 8.75 5.70312 8.75 5L8.75 1.875L2.5 1.875C2.14844 1.875 1.875 2.1875 1.875 2.5L1.875 17.5C1.875 17.8516 2.14844 18.125 2.5 18.125L12.5 18.125ZM0 2.5C0 1.13281 1.09375 0 2.5 0L8.94531 0C9.60938 0 10.2344 0.273438 10.7031 0.742188L14.2578 4.29688C14.7266 4.76562 15 5.39062 15 6.05469L15 17.5C15 18.9062 13.8672 20 12.5 20L2.5 20C1.09375 20 0 18.9062 0 17.5L0 2.5Z"
                              />
                            </MoneyBill_0007>
                          </Frame1544_0001>
                        </MoneyBill_0002>
                        <MutualSuccess_0003>
                          No HRMC reporting
                        </MutualSuccess_0003>
                      </Frame1534>
                      <PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                        Paartner’s mutual success model means that rewards are
                        only due when you win a deal.
                      </PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal>
                    </ContenBox533>
                  </Frame47>
                </Frame1536>
              </Content_0001>
              <Image_0007>
                <Frame1530>
                  <Frame1533_0001>
                    <Frame1531>
                      <NaN_0001>“</NaN_0001>
                    </Frame1531>
                    <Frame1532_0001>
                      <CustomerRefferalsAccountFor54OfAllB2BLeads>
                        Referrals are the most effective B2B marketing tactic."
                      </CustomerRefferalsAccountFor54OfAllB2BLeads>
                      <SellersCommerce>TrustRadius</SellersCommerce>
                    </Frame1532_0001>
                  </Frame1533_0001>
                </Frame1530>
              </Image_0007>
            </ContentBlock1_0001>
          </AnimateOnScroll>
        </Wrapper>
      </Section_0001>
      <Section>
        <Wrapper>
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Vendors>
              <ContentBlock1>
                <Content_0009>
                  <EarningCashForMakingReferralsIsEasierThanEver>
                    Nominate a Vendor
                  </EarningCashForMakingReferralsIsEasierThanEver>
                  <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed_0001>
                    Paartner is always happy to learn about vendors that
                    marketers love to work with. <br />
                    Thank you for sharing your nominations with us.
                  </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed_0001>
                </Content_0009>
              </ContentBlock1>

              <Frame58>
                <ToNominateAVendorPleaseFillInTheFormBelowAndLetUsKnowWhyYouThinkTheyWouldBeAGreatFitOurTeamOfWiseOwlsWillPickItUpFromThereUnderstandingTheirServicesTechnologyAndReputationTheMoreHappyCustomersTheyHaveTheMoreLikelyTheyAreToReceiveAnInvitation>
                  To nominate a vendor, please fill in the form below and let us
                  know why you think they would be a great fit. Our team of wise
                  owls will pick it up from there, understanding their services,
                  technology and reputation. The more happy customers they have,
                  the more likely they are to receive an invitation.
                </ToNominateAVendorPleaseFillInTheFormBelowAndLetUsKnowWhyYouThinkTheyWouldBeAGreatFitOurTeamOfWiseOwlsWillPickItUpFromThereUnderstandingTheirServicesTechnologyAndReputationTheMoreHappyCustomersTheyHaveTheMoreLikelyTheyAreToReceiveAnInvitation>
                <Frame1409>
                  <PRTNR.Input
                    label="First Name"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                    error={hasSubmitted && !formData.first_name}
                    errorMessage={"Required Field"}
                  />

                  <PRTNR.Input
                    label="Last Name"
                    name="last_name"
                    value={formData.last_name}
                    onChange={(val) => handleChange(val, "phone_number")}
                    required
                    error={hasSubmitted && !formData.last_name}
                    errorMessage={"Required Field"}
                  />
                </Frame1409>
                {/* 
                <PRTNR.Input
                  label="Phone"
                  name={"phone_number"}
                  value={formData.phone_number}
                  onChange={handleChange}
                  required
                  error={hasSubmitted && !formData.phone_number}
                  errorMessage={"Required Field"}
                /> */}

                <PRTNR.PhoneInputField
                  label="Phone"
                  name={"phone_number"}
                  value={formData.phone_number}
                  onChange={(val) =>
                    setFormData((prev) => ({ ...prev, phone_number: val }))
                  }
                  required
                  error={
                    hasSubmitted &&
                    (!formData.phone_number ||
                      !isValidPhoneNumber(formData.phone_number))
                  }
                  errorMessage={
                    !formData.phone_number
                      ? "Required Field"
                      : "Phone number must be 10 to 15 digits"
                  }
                />

                <PRTNR.Input
                  label="Email Address"
                  name={"email_address"}
                  value={formData.email_address}
                  onChange={handleChange}
                  required
                  error={hasSubmitted && !formData.email_address}
                  errorMessage={"Required Field"}
                />

                <PRTNR.Input
                  label="Company Name of the Vendor"
                  name={"company_name"}
                  value={formData.company_name}
                  onChange={handleChange}
                  required
                  error={hasSubmitted && !formData.company_name}
                  errorMessage={"Required Field"}
                />

                <PRTNR.Input
                  label="Vendor’s Website"
                  name={"company_website"}
                  value={formData.company_website}
                  onChange={handleChange}
                  required
                  error={hasSubmitted && !formData.company_website}
                  errorMessage={"Required Field"}
                />
                <PRTNR.TextArea
                  label="Reason for your nomination"
                  name="reason_for_nomination"
                  value={formData.reason_for_nomination}
                  required
                  error={hasSubmitted && !formData.reason_for_nomination}
                  errorMessage={"Required Field"}
                  onChange={handleChange}
                />

                <Frame59>
                  <AIMEButton
                    size="small"
                    type="submit"
                    disabled={postStatus === "loading"}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "10px",
                      borderRadius: "48px",
                      width: "320px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                      "&:hover": {
                        background: "rgb(33, 37, 67)",
                        opacity: "0.9",
                      },
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      Submit
                    </span>
                  </AIMEButton>
                </Frame59>
              </Frame58>
            </Vendors>
          </form>
        </Wrapper>
      </Section>
      <Footer showBanner={false} />

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalVendornominate
          isOpen={isModalOpen}
          onClose={() => {
            closeModal();
          }}
          buttonOnclick={() => {
            closeModal();
            toast.success("Vendor recommendation submitted!");
            setNominateModalOpen(true);
          }}
        />
      </GenericModal>
      <GenericModal
        isOpen={nominateModalOpen}
        onClose={() => setNominateModalOpen(!nominateModalOpen)}
      >
        <NominateSuccessModal
          isOpen={isModalOpen}
          onClose={() => {
            setNominateModalOpen(!nominateModalOpen);
            // add login navigation
            navigate("/login");
          }}
        />
      </GenericModal>
    </RootWrapperVendornominate>
  );
}

const RootWrapperVendornominate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  /* padding-top: 98px;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding-top: 73px;
  }

  @media (max-width: 767px) {
    padding-top: 73px;
  } */
`;

const SectionBanner2 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const Frame19 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  border-radius: 32px;
  align-self: stretch;
  height: 540px;
  background: radial-gradient(white, rgb(136, 204, 235));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 16px 32px;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 16px 32px;
    gap: 24px;
  }
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 380px;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const OwlArrow1 = styled.img`
  width: 380px;
  height: 472px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 48px;
  width: 700px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame6 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const UnlockThePowerOfReferrals = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 68px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -2px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 22px;
    text-align: center;
  }

  @media (max-width: 767px) {
    font-size: 22px;
    text-align: center;
  }
`;

const PaartnerBelievesThatThoseWhoCanConnectTheirFriendsToTheServiceProvidersAgenciesAndTechPlatformsThatCanHelpThemShouldBeEncouragedAndRewardedForDoingSo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 13px;
    text-align: center;
  }

  @media (max-width: 767px) {
    font-size: 13px;
    text-align: center;
  }
`;

const Glow = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-end;
  flex: none;
  height: 60px;
  box-sizing: border-box;
`;

const Ellipse2 = styled.div`
  width: 400px;
  height: 400px;
  background: linear-gradient(-90deg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 400px / 400px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Ellipse1 = styled.div`
  width: 596px;
  height: 400px;
  background: linear-gradient(-90deg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 596px / 400px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    padding: 32px 16px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 60px 16px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    padding: 0px 24px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 60px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding: 32px 16px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 32px 16px;
  }
`;

const ContentBlock1_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: ${(props) => props.direction || "column"};
  }
`;

const Image = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  width: 584px;
  height: 580px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1749636644192-d9447d9dfee9effd622d43d80855a66bcf9e6539.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    height: 300px;
    min-height: 300px;
  }

  @media (max-width: 767px) {
    width: 100%;
    min-height: 300px;
  }
`;

const Frame1530 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  border-radius: 16px;
  align-self: stretch;
  width: 584px;
  background: linear-gradient(
    -90deg,
    rgba(226, 232, 240, 0.4),
    rgba(226, 232, 240, 0.4)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  flex-shrink: 0;
  backdrop-filter: blur(50px);
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1533 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  box-sizing: border-box;
`;

const Frame1531 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  margin-top: -50px;
  @media (max-width: 1024px) and (min-width: 768px) {
    margin-top: -50px;
  }

  @media (max-width: 767px) {
    margin-top: -50px;
  }
`;

const NaN_0001 = styled.span`
  color: rgb(97, 98, 197);
  text-overflow: ellipsis;
  font-size: 128px;
  font-family: "Times New Roman", sans-serif;
  font-weight: 700;
  letter-spacing: -4px;
  text-align: left;
  width: 64px;
`;

const Frame1532 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 316px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 70%;
  }

  @media (max-width: 767px) {
    width: 70%;
  }
`;

const CustomerRefferalsAccountFor54OfAllB2BLeads = styled.span`
  color: rgb(97, 98, 197);
  text-overflow: ellipsis;
  font-size: 28px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const SellersCommerce = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Content_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 584px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame12 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 8px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
`;

const Leads = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame46 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame46_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 584px;
  box-sizing: border-box;
  padding: 16px 0px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const IncreaseSalesPipeline = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: left;
  width: 586px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    font-size: 28px;
    letter-spacing: -3%;
  }

  @media (max-width: 767px) {
    width: 100%;
    font-size: 28px;
    letter-spacing: -3%;
  }
`;

const PaartnerCanHelpYouFillYourFirmSSalesPipelineWithQualityLeadsDrivingReferralsFromMembersThatUnderstandYourFirmUnderstandTheProspectSNeedsAndFeelThereIsAGoodFit = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const Frame46_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px 0px;
  flex-shrink: 0;
`;

const IncreaseSalesPipeline_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: left;
  width: 584px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    font-size: 28px;
    letter-spacing: -3%;
  }

  @media (max-width: 767px) {
    width: 100%;
    font-size: 28px;
    letter-spacing: -3%;
  }
`;

const Frame1533_0001 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  width: 380px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1532_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 316px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1535 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px 0px;
  flex-shrink: 0;
`;

const Devider = styled.div`
  height: 1px;
  background: linear-gradient(
    -90deg,
    rgba(136, 136, 136, 0.1),
    rgba(136, 136, 136, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1536 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame47 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const ContentBox532 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  width: 280px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1534 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const MoneyBill = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 23px;
  box-sizing: border-box;
`;

const Frame1544 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const MoneyBill_0001 = styled.svg`
  width: 23px;
  height: 15px;
`;

const MutualSuccess = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 244px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
`;

const PaartnerSMutualSuccessModelMeansThatRewardsAreOnlyDueWhenYouWinADeal = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 767px) {
    text-align: center;
  }
`;

const ContenBox533 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  width: 280px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
`;

const MoneyBill_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame1544_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const MoneyBill_0003 = styled.svg`
  width: 16px;
  height: 20px;
`;

const MutualSuccess_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 248px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    text-align: center;
  }

  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
`;

const MoneyBill_0005 = styled.svg`
  width: 25px;
  height: 15px;
`;

const MutualSuccess_0002 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 242px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    text-align: center;
  }

  @media (max-width: 767px) {
    width: 100%;
    text-align: center;
  }
`;

const MoneyBill_0007 = styled.svg`
  width: 15px;
  height: 20px;
`;

const MutualSuccess_0003 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 251px;
  flex: 1;
`;

const Image_0007 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 16px;
  align-self: stretch;
  width: 584px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1749636703346-d9447d9dfee9effd622d43d80855a66bcf9e6539 (1).png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    height: 300px;
    min-height: 300px;
  }

  @media (max-width: 767px) {
    width: 100%;
    height: 300px;
    min-height: 300px;
  }
`;

const Vendors = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content_0009 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 1200px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 960px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 16px;
  }
`;

const ToNominateAVendorPleaseFillInTheFormBelowAndLetUsKnowWhyYouThinkTheyWouldBeAGreatFitOurTeamOfWiseOwlsWillPickItUpFromThereUnderstandingTheirServicesTechnologyAndReputationTheMoreHappyCustomersTheyHaveTheMoreLikelyTheyAreToReceiveAnInvitation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 767px) {
    font-size: 14px;
  }
`;

const Frame1409 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
